import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  Home,
  Users,
  BookOpen,
  Calendar,
  CreditCard,
  Award,
  Settings,
  LogOut,
} from "lucide-react";

const Sidebar = () => {
  const { currentUser, logout } = useAuth();

  let navItems = [];

  if (
    currentUser?.role?.name &&
    ["admin"].includes(currentUser.role.name.toLowerCase())
  ) {
    navItems.push({
      name: "Dashboard",
      path: "/",
      icon: <Home size={20} />,
    });
  }

  if (
    currentUser?.role?.name &&
    ["admin", "instructor"].includes(currentUser.role.name.toLowerCase())
  ) {
    navItems.push({
      name: "Courses",
      path: "/courses",
      icon: <BookOpen size={20} />,
    });
  }

  if (
    currentUser?.role?.name &&
    ["admin", "instructor"].includes(currentUser.role.name.toLowerCase())
  ) {
    navItems.push({
      name: "Attendance",
      path: "/attendance",
      icon: <Calendar size={20} />,
    });
  }

  if (
    currentUser?.role?.name &&
    ["admin", "accountant"].includes(currentUser.role.name.toLowerCase())
  ) {
    navItems.push({
      name: "Payments",
      path: "/payments",
      icon: <CreditCard size={20} />,
    });
  }

  if (
    currentUser?.role?.name &&
    ["admin", "coordinator"].includes(currentUser.role.name.toLowerCase())
  ) {
    navItems.push({
      name: "Students",
      path: "/students",
      icon: <Award size={20} />,
    });
  }
  if (
    currentUser?.role?.name &&
    ["admin"].includes(currentUser.role.name.toLowerCase())
  ) {
    navItems.push({
      name: "Certificates",
      path: "/certifications",
      icon: <Settings size={20} />,
    });
  }

  if (
    currentUser?.role?.name &&
    ["admin"].includes(currentUser.role.name.toLowerCase())
  ) {
    navItems.push({
      name: "User Management",
      path: "/users",
      icon: <Settings size={20} />,
    });
  }

  return (
    <aside className="flex flex-col justify-between w-64 min-h-screen p-4 text-white shadow-xl bg-gradient-to-b from-primary to-purple-700 animate-fadeIn">
      <div>
        <h1 className="mb-8 text-3xl font-bold tracking-wide text-center transition-transform duration-300 hover:scale-105">
          Makeup Academy
        </h1>
        <nav>
          <ul className="space-y-4">
            {navItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center gap-3 p-3 rounded-lg transition-all duration-300 hover:bg-white hover:text-primary ${
                      isActive ? "bg-white text-primary font-semibold" : ""
                    }`
                  }
                >
                  <span className="transition-transform duration-300 group-hover:scale-110">
                    {item.icon}
                  </span>
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="pt-4 mt-8 border-t border-white/30">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex items-center justify-center w-10 h-10 text-lg font-bold bg-white rounded-full text-primary">
            {currentUser?.firstName ? currentUser.firstName.charAt(0) : "U"}
          </div>
          <div>
            <p className="font-semibold text-primary">
              {currentUser?.firstName && currentUser?.lastName
                ? `${currentUser.firstName} ${currentUser.lastName}`
                : currentUser?.name || "User"}
            </p>
            <p className="text-sm opacity-80 text-primary">
              {currentUser?.role?.name ? currentUser.role.name : "Role"}
            </p>
          </div>
        </div>
        <button
          onClick={logout}
          className="flex items-center w-full gap-2 p-3 font-medium text-white transition-all duration-300 bg-red-500 rounded-lg hover:bg-red-600"
        >
          <LogOut size={20} />
          Logout
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
